import { render, staticRenderFns } from "./replace-material-modal.vue?vue&type=template&id=5f647ae8&scoped=true"
import script from "./replace-material-modal.vue?vue&type=script&lang=js"
export * from "./replace-material-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f647ae8",
  null
  
)

export default component.exports